// Varastonhallinnan yhteiset esitysmuodot: määrät ja hinnat suomalaisittain pilkulla, yksikön oletus kpl.
export const PIECES_UNIT = 'kpl';

export function unitLabel(item) {
  return (item && item.unit) || PIECES_UNIT;
}

export function formatQuantity(value) {
  if (value === null || value === undefined || value === '') return '0';
  return Number(value).toLocaleString('fi-FI', { maximumFractionDigits: 3 });
}

export function formatEuro(value) {
  if (value === null || value === undefined) return '';
  return Number(value).toLocaleString('fi-FI', { style: 'currency', currency: 'EUR' });
}

export function formatIsoDateFi(date) {
  if (!date) return '';
  const [y, m, d] = date.split('-');
  return `${d}.${m}.${y}`;
}

export function todayIso() {
  return new Date().toISOString().substr(0, 10);
}
